import { render, staticRenderFns } from "./AnagraficheMenu.vue?vue&type=template&id=40a04d9c&"
import script from "./AnagraficheMenu.vue?vue&type=script&lang=ts&"
export * from "./AnagraficheMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports